import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  getUserDistributionSummaryActionHandler,
  getUserVisualReportActionHandler,
  getFilterUserVisualReportActionHandler,
  getFilterUserDistributionSummaryActionHandler,
  getTenantUsersActionHandler,
  getTrainingTypesActionHandler,
} from "../../../../store/actions/actionHandlers/reportActionHandler";
import moment from "moment";
import Dropdown from "../../../../components/Common/ReactForm/Dropdown/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/Common/Button/Button";
import classes from "./UserGraphicalReport.module.scss";
import Input from "../../../../components/Common/ReactForm/Input/Input";
import ReportGraph from "../../ReportGraph/ReportGraph";
import { errorTypes } from "../../../../utils/errorTypes";
import { setErrorAction } from "../../../../store/actions/actionCreators/errorActionCreator";
import { userGraphicalReport } from "../../../../utils/mainTabs/reports/userGraphicalReport";
import ReportGraphFilterLayout from "../../ReportGraphFilterLayout/ReportGraphFilterLayout";
import { FormattedMessage, injectIntl } from "react-intl";
import InputHookForm from "../../../../components/Common/Input/Input";
import { FormProvider, useForm } from "react-hook-form";
import { getUserGroupsActionHandler } from "../../../../store/actions/actionHandlers/organizeActionHandler";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  getClassDistributionSummaryAction,
  getTrainingTypesAction,
  getUserDistributionSummaryAction,
  getUserVisualReportAction,
} from "../../../../store/actions/actionCreators/reportActionCreator";

const chartColors = [
  "#1f77b4",
  "#ff7f0e",
  "#2ca02c",
  "#d62728",
  "#9467bd",
  "#8c564b",
  "#e377c2",
  "#7f7f7f",
  "#bcbd22",
  "#17becf",
];

export const graphicalReportSchema = yup.object().shape({
  UserGroupDetails: yup
    .array(
      yup.object().shape({
        FirstName: yup.string(),
        Id: yup.number(),
      })
    )
    .min(1, "Select at least One User to proceed")
    .max(5, "Maximum 5 User are allowed"),
  TrainingTypes: yup
    .array(
      yup.object().shape({
        Name: yup.string(),
        TypeId: yup.number(),
      })
    )
    // .min(1, "Select at least One User to proceed")
    .max(15, "Maximum 15 Training Types are allowed"),
});

const UserGraphicalReport = ({ intl }) => {
  const dispatch = useDispatch();
  const inputFile = useRef(null);
  const reportState = useSelector((state) => state.reportReducer);
  const {
    userVisualReport,
    userDistributionSummary,
    filterUserVisualReport,
    filterUserDistributionSummary,
    trainingTypes,
    tenantUsers,
  } = reportState;
  const { SUCCESS, FAIL, WARN } = errorTypes;
  const [searchClicked, setSearchClicked] = useState(false);

  const { inputField } = userGraphicalReport;

  const filterUserMostCreditData = filterUserVisualReport?.MostCredit;
  const filterUserMostPassedData = filterUserVisualReport?.MostPassed;
  const filterUserMostRatedData = filterUserVisualReport?.MostRated;

  const filterUserCompletedData =
    filterUserDistributionSummary?.CompletedLineData;
  const filterUserNotYetCompletedData =
    filterUserDistributionSummary?.NotYetCompletedLineData;
  const filterUserInProgressData =
    filterUserDistributionSummary?.InProgressLineData;

  let userDoughnutChartColors = ["#0b931f", "#2c92de", "#E00000"];

  const [trainingTypesOptions, setTrainingTypesOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);

  const [selectedTraining, setSelctedTraining] = useState([]);
  const [selectedUser, setselectedUser] = useState([]);
  const [formData, setFormData] = useState([]);
  const [fromDate, setFromDate] = useState();

  const onTrainingSelected = (selected) => {
    setSelctedTraining(selected);
  };

  const onSelectedUserSelected = (selected) => {
    setselectedUser(selected);
  };
  let selectedTrainingType = selectedTraining?.map((opt) => opt.value);
  let selectedUserName = selectedUser?.map((opt) => opt.value);

  let filterUserTotal =
    filterUserDistributionSummary?.Completed +
    filterUserDistributionSummary?.NotStartedYet +
    filterUserDistributionSummary?.InProgress;
  let filterUserCompletedPercent = 0;
  if (filterUserDistributionSummary?.Completed === 0)
    filterUserCompletedPercent = filterUserDistributionSummary?.Completed;
  else
    filterUserCompletedPercent =
      (filterUserDistributionSummary?.Completed / filterUserTotal) * 100;
  let filterUserCompletedPercentage = Math.round(filterUserCompletedPercent);

  let filterUserNotStartedYetPercent = null;
  if (filterUserDistributionSummary?.NotStartedYet === 0)
    filterUserNotStartedYetPercent =
      filterUserDistributionSummary?.NotStartedYet;
  else
    filterUserNotStartedYetPercent =
      (filterUserDistributionSummary?.NotStartedYet / filterUserTotal) * 100;
  let filterUserNotStartedYetPercentage = Math.round(
    filterUserNotStartedYetPercent
  );

  let filterUserInProgessPercent = null;
  if (filterUserDistributionSummary?.InProgress === 0)
    filterUserInProgessPercent = filterUserDistributionSummary?.InProgress;
  else
    filterUserInProgessPercent =
      (filterUserDistributionSummary?.InProgress / filterUserTotal) * 100;
  let filterUserInProgressPercentage = Math.round(filterUserInProgessPercent);

  const filterUserCreditBarData = {
    labels: filterUserMostCreditData?.map((el) => el.LoginId),
    datasets: [
      {
        data: filterUserMostCreditData?.map((el) => el.Value),
        backgroundColor: chartColors,
      },
    ],
  };
  const filterUserPassedBarData = {
    labels: filterUserMostPassedData?.map((el) => el.LoginId),
    datasets: [
      {
        data: filterUserMostPassedData?.map((el) => el.Value),
        backgroundColor: chartColors,
      },
    ],
  };
  const filterUserRatedBarData = {
    labels: filterUserMostRatedData?.map((el) => el.LoginId),
    datasets: [
      {
        data: filterUserMostRatedData?.map((el) => el.Value),
        backgroundColor: chartColors,
      },
    ],
  };
  const filterUserDistributionDoughnutData = {
    labels: ["Completed", "In Progress", "Not Started Yet"],
    datasets: [
      {
        data: [
          filterUserCompletedPercentage,
          filterUserInProgressPercentage,
          filterUserNotStartedYetPercentage,
        ],
        backgroundColor: userDoughnutChartColors,
      },
    ],
  };
  const filterUserLineData = {
    labels: filterUserCompletedData
      ?.map((el) => moment(el.Date).format("DD-MMM-YY"))
      .reverse(),
    datasets: [
      {
        data: filterUserInProgressData?.map((el) => el.Value).reverse(),
        borderColor: "#2c92de",
        backgroundColor: "#2c92de",
        tension: 0.2,
        borderWidth: 2,
      },
      {
        data: filterUserNotYetCompletedData?.map((el) => el.Value).reverse(),
        borderColor: "#E00000",
        backgroundColor: "#E00000",
        tension: 0.2,
        borderWidth: 2,
      },
      {
        data: filterUserCompletedData?.map((el) => el.Value).reverse(),
        borderColor: "#0b931f",
        backgroundColor: "#0b931f",
        tension: 0.2,
        borderWidth: 2,
      },
    ],
  };
  const userMostCreditData = userVisualReport?.MostCredit;
  const userMostPassedData = userVisualReport?.MostPassed;
  const userMostRatedData = userVisualReport?.MostRated;

  const userCompletedData = userDistributionSummary?.CompletedLineData;
  const userInProgressData = userDistributionSummary?.InProgressLineData;
  const userNotYetCompletedData =
    userDistributionSummary?.NotYetCompletedLineData;

  let userTotal =
    userDistributionSummary?.Completed +
    userDistributionSummary?.NotStartedYet +
    userDistributionSummary?.InProgress;
  let userCompletePercent = 0;
  if (userDistributionSummary?.Completed === 0)
    userCompletePercent = userDistributionSummary?.Completed;
  else
    userCompletePercent =
      (userDistributionSummary?.Completed / userTotal) * 100;
  let userCompletePercentage = Math.round(userCompletePercent);
  let userNotStartedYetPercent = null;
  if (userDistributionSummary?.NotStartedYet === 0)
    userNotStartedYetPercent = userDistributionSummary?.NotStartedYet;
  else
    userNotStartedYetPercent =
      (userDistributionSummary?.NotStartedYet / userTotal) * 100;
  let userNotStartedYetPercentage = Math.round(userNotStartedYetPercent);

  let userInProgessPercent = null;
  if (userDistributionSummary?.InProgress === 0)
    userInProgessPercent = userDistributionSummary?.InProgress;
  else
    userInProgessPercent =
      (userDistributionSummary?.InProgress / userTotal) * 100;
  let userInProgressPercentage = Math.round(userInProgessPercent);

  const userCreditBarData = {
    labels: userMostCreditData?.map((el) => el.LoginId),
    datasets: [
      {
        data: userMostCreditData?.map((el) => el.Value),
        backgroundColor: chartColors,
      },
    ],
  };

  const userPassBarData = {
    labels: userMostPassedData?.map((el) => el.LoginId),
    datasets: [
      {
        data: userMostPassedData?.map((el) => el.Value),
        backgroundColor: chartColors,
      },
    ],
  };

  const userRatedBarData = {
    labels: userMostRatedData?.map((el) => el.LoginId),
    datasets: [
      {
        data: userMostRatedData?.map((el) => el.Value),
        backgroundColor: chartColors,
      },
    ],
  };

  const userDistributionDoughnutData = {
    labels: ["Completed", "In Progress", "Not Started Yet"],
    datasets: [
      {
        data: [
          userCompletePercentage,
          userInProgressPercentage,
          userNotStartedYetPercentage,
        ],
        backgroundColor: userDoughnutChartColors,
      },
    ],
  };

  const userLineData = {
    labels: userCompletedData
      ?.map((el) => moment(el.Date).format("DD-MMM-YY"))
      .reverse(),
    datasets: [
      {
        data: userInProgressData?.map((el) => el.Value).reverse(),
        borderColor: "#2c92de",
        backgroundColor: "#2c92de",
        tension: 0.2,
        borderWidth: 2,
      },
      {
        data: userNotYetCompletedData?.map((el) => el.Value).reverse(),
        borderColor: "#E00000",
        backgroundColor: "#E00000",
        tension: 0.2,
        borderWidth: 2,
      },
      {
        data: userCompletedData?.map((el) => el.Value).reverse(),
        borderColor: "#0b931f",
        backgroundColor: "#0b931f",
        tension: 0.2,
        borderWidth: 2,
      },
    ],
  };

  let filterUserLineDataTotal =
    filterUserCompletedData +
    filterUserInProgressData +
    filterUserNotYetCompletedData;

  let userLineDataTotal =
    userCompletedData + userNotYetCompletedData + userInProgressData;

  useEffect(() => {
    const trainingOptions = trainingTypes?.map((d) => ({
      label: d.Name,
      value: d.TypeId,
    }));
    const userOptions = tenantUsers?.map((d) => ({
      label: d.FirstName + " " + d.LastName,
      value: d.Id,
    }));
    setTrainingTypesOptions(trainingOptions);
    setUserOptions(userOptions);
  }, [trainingTypes, tenantUsers]);

  useEffect(() => {
    dispatch(getUserVisualReportActionHandler());
    dispatch(getUserDistributionSummaryActionHandler());
    dispatch(getTenantUsersActionHandler());
    dispatch(getTrainingTypesActionHandler());
  }, [dispatch]);
  const [toDate, setToDate] = useState();
  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");
  const onFromDateChange = (date) => {
    setFromDateValue(date.target.value);
    setFromDate(new Date(date.target.value).toLocaleDateString());
  };

  const onToDateChange = (date) => {
    setToDateValue(date.target.value);
    const newDate = moment(date.target.value).format("DD/MM/YYYY");
    setToDate(newDate);
  };

  let date = moment(fromDate).format("DD/MM/YYYY") + "-" + toDate;

  const onFilterSearch = () => {
    if (selectedUser.length > 0 && selectedUser.length < 6 && selectedTraining.length < 16) {
      setSearchClicked(true);
    } else if (selectedUser.length > 5) {
      dispatch(setErrorAction("WARN", "You Can Selet Max 5 User"));
    } else if (selectedTraining.length > 15) {
      dispatch(setErrorAction("WARN", "You Can Selet Max 15 Training Types"));
    } else {
      dispatch(setErrorAction("WARN", "Select at least One User"));
    }
    if (fromDate && toDate) {
      dispatch(
        getFilterUserDistributionSummaryActionHandler(
          selectedUserName,
          selectedTrainingType,
          date
        )
      );
      dispatch(
        getFilterUserVisualReportActionHandler(
          selectedUserName,
          selectedTrainingType,
          date
        )
      );
    } else {
      dispatch(
        getFilterUserDistributionSummaryActionHandler(
          selectedUserName,
          selectedTrainingType
        )
      );
      dispatch(
        getFilterUserVisualReportActionHandler(
          selectedUserName,
          selectedTrainingType
        )
      );
    }
  };
  const handleReset = () => {
    setSelctedTraining([]);
    setselectedUser([]);
    reset();
    setUpdatedUserGroups(tenantUsers);
    setUpdatedTrainingList(trainingTypes);
    setFromDateValue("");
    setToDateValue("");
     setFromDate(moment().format("dd-mm-yyyy"));
    setFromDate(null);
    setSearchClicked(false);
  };
console.log(fromDate)
  let totalUserData =
    filterUserTotal +
    filterUserLineDataTotal?.length +
    filterUserMostRatedData?.length +
    filterUserMostPassedData?.length +
    filterUserMostCreditData?.length;
  useEffect(() => {
    let formArgs = {
      selectedUser,
      userOptions,
      onSelectedUserSelected,
      onFromDateChange,
      onToDateChange,
      fromDate,
      selectedTraining,
      trainingTypesOptions,
      onTrainingSelected,
      handleReset,
      onFilterSearch,
    };
    let data = inputField(formArgs);
    setFormData(data);
  }, [selectedTraining, selectedUser, userOptions]);

  // mukesh changes

  //User Group
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(graphicalReportSchema),
  });
  const {
    formState: { errors },
    reset,
  } = methods;

  const [userGroupList, setUserGroupList] = useState([]);
  let setUpdatedUserGroups = useCallback(
    (tenantUsers) => {
      if (tenantUsers?.length > 0) {
        let updatedUserGroup = tenantUsers.map((userGroup) => {
          return { ...userGroup, isVisible: true };
        });
        setUserGroupList(updatedUserGroup);
      }
    },
    [tenantUsers, userGroupList]
  );
  useEffect(() => {
    setUpdatedUserGroups(tenantUsers);
  }, [dispatch, tenantUsers]);

  useEffect(() => {
    if (userGroupList.length > 0) {
      const filtered = userGroupList.filter((item) => {
        return item.checked === true;
      });
      let updateFilteredResult = filtered.map((item) => {
        return { label: item.FirstName + "" + item.LastName, value: item.Id };
      });
      setselectedUser(updateFilteredResult);
    }
  }, [userGroupList, setselectedUser]);

  //mukesh Training Types

  const [trainingTypesList, setTrainingTypesList] = useState([]);
  let setUpdatedTrainingList = useCallback(
    (trainingTypes) => {
      if (trainingTypes?.length > 0) {
        let updatedUserGroup = trainingTypes.map((userGroup) => {
          return { ...userGroup, isVisible: true };
        });
        setTrainingTypesList(updatedUserGroup);
      }
    },
    [trainingTypes, setTrainingTypesList]
  );
  useEffect(() => {
    setUpdatedTrainingList(trainingTypes);
  }, [dispatch, tenantUsers, trainingTypes]);

  useEffect(() => {
    if (trainingTypesList.length > 0) {
      const filtered = trainingTypesList.filter((item) => {
        return item.checked === true;
      });
      let updateFilteredResult = filtered.map((item) => {
        return { labe: item.Name, value: item.TypeId };
      });
      setSelctedTraining(updateFilteredResult);
    }
  }, [trainingTypesList, setSelctedTraining]);
  return (
    <>
      <div className={classes.reportFilter_Main}>
        <FormProvider {...methods}>
          <div className={classes.reportFilter_userCLass}>
            {/* <Dropdown
            isMulti
            isRequired
            name={"userSelect"}
            label={<FormattedMessage id="Select_Users" />}
            isLimit
            defaultValue={selectedUser}
            placeholder={intl.formatMessage({
              id: `Select_Users`,
            })}
            options={userOptions}
            onChange={onSelectedUserSelected}
            maxSelected={5}
            validationLabel="Users"
            selectedValue={selectedUser}
          /> */}
            <InputHookForm
              label={<FormattedMessage id="Select_Users" />}
              name="UserGroupDetails"
              // labelColor="light"
              type="noSearchTags"
              fieldName={"FirstName"}
              fieldValue="Id"
              placeholder={intl.formatMessage({
                id: `ANALYTICAL_SEARCH_USER_TEXT`,
              })}
              labelMsg="(Max: 5 Users)"
              height="3.9"
              width="24.5"
              required
              labelColor={"#404040"}
              searchable={true}
              id={"Id"}
              searchTagsList={userGroupList}
              handleTagList={(tagsList) => {
                setUserGroupList(tagsList);
              }}
              error={errors?.UserGroupDetails?.message}
            />

            <Input
              label={"From Date"}
              type={"date"}
              isFromDate
              value={fromDateValue}
              onChange={onFromDateChange}
            />
            <Input
              label={"To Date"}
              type={"date"}
              min={fromDate}
              value={toDateValue}
              onChange={onToDateChange}
            />
            <InputHookForm
              label={<FormattedMessage id="TRAINING_TYPE_TEXT" />}
              name="TrainingTypes"
              type="noSearchTags"
              fieldName={"Name"}
              fieldValue="TypeId"
              placeholder="Search Training Types"
              labelMsg="(Max: 15 Training Types)"
              height="3.9"
              width="24.5"
              labelColor={"#404040"}
              searchable={true}
              id={"TypeId"}
              searchTagsList={trainingTypesList}
              handleTagList={(tagsList) => {
                setTrainingTypesList(tagsList);
              }}
              error={errors?.TrainingTypes?.message}
            />

            {/* <Dropdown
            label={<FormattedMessage id="TRAINING_TYPE_TEXT" />}
            isMulti
            isLimit
            defaultValue={selectedTraining}
            placeholder="Select Training Type"
            maxSelected={15}
            validationLabel="Trainings"
            options={trainingTypesOptions}
            onChange={onTrainingSelected}
            selectedValue={selectedTraining}
          /> */}
          </div>
          <div className={classes.searchResetButton}>
            <span
              style={{
                textDecoration: "underline",
                color: "#0051BC",
                cursor: "pointer",
                paddingTop: "12px",
              }}
              onClick={handleReset}
            >
              <FormattedMessage id="ANALYTICAL_REPORT_RESET" />
            </span>
            <Button
              label={<FormattedMessage id="P_Search" />}
              dark
              small
              className={classes.searchButton}
              onClick={onFilterSearch}
            />
          </div>
        </FormProvider>
      </div>
      {/* <ReportGraphFilterLayout inputField={formData} /> */}
      {searchClicked ? (
        <div className={classes.graphicalReport_mainLayout}>
          <div className={classes.graphicalReport_doughnut_main}>
            <div className={classes.graphicalReport_doughnut}>
              <ReportGraph
                type={"doughnut"}
                graphData={filterUserDistributionDoughnutData}
                totalPercentage={filterUserTotal}
                heading={<FormattedMessage id="VisualReport_User" />}
              />
            </div>
            <div className={classes.graphicalReport_line}>
              <ReportGraph
                type={"lineGraph"}
                totalPercentage={filterUserLineDataTotal?.length}
                heading={<FormattedMessage id="MyClassStatus_lbl" />}
                yAxesText={"Distribution Count"}
                xAxesText={"Assigned Date (dd-MMM-yy)"}
                graphData={filterUserLineData}
              />
            </div>
          </div>
          <div className={classes.graphicalReport_bar_main}>
            <div className={classes.graphicalReport_bar}>
              <ReportGraph
                type={"verticalBar"}
                totalPercentage={filterUserMostRatedData?.length}
                heading={"Top 10 Most Rated"}
                graphData={filterUserRatedBarData}
                xAxesText={"LoginId"}
                yAxesText={"Rated Count"}
              />
            </div>
            <div className={classes.graphicalReport_bar}>
              <ReportGraph
                type={"verticalBar"}
                totalPercentage={filterUserMostPassedData?.length}
                heading={"Top 10 Most Passed"}
                graphData={filterUserPassedBarData}
                xAxesText={"LoginId"}
                yAxesText={"Passed Count"}
              />
            </div>
          </div>
          {/* <div className={classes.graphicalReport_bar_main}>
            <div className={classes.graphicalReport_bar}>
              <ReportGraph
                type={"verticalBar"}
                totalPercentage={filterUserMostCreditData?.length}
                heading={"Top 10 Most Credit"}
                graphData={filterUserCreditBarData}
                xAxesText={"LoginId"}
                yAxesText={"Credit Count"}
              />
            </div>
          </div> */}
        </div>
      ) : (
        <div className={classes.graphicalReport_mainLayout}>
          <div className={classes.graphicalReport_doughnut_main}>
            <div className={classes.graphicalReport_doughnut}>
              <ReportGraph
                type={"doughnut"}
                graphData={userDistributionDoughnutData}
                heading={<FormattedMessage id="VisualReport_User" />}
                totalPercentage={userTotal}
              />
            </div>
            <div className={classes.graphicalReport_line}>
              <ReportGraph
                type={"lineGraph"}
                yAxesText={"Distribution Count"}
                xAxesText={"Assigned Date (dd-MMM-yy)"}
                totalPercentage={userLineDataTotal?.length}
                heading={<FormattedMessage id="MyClassStatus_lbl" />}
                graphData={userLineData}
              />
            </div>
          </div>
          <div className={classes.graphicalReport_bar_main}>
            <div className={classes.graphicalReport_bar}>
              <ReportGraph
                totalPercentage={userMostRatedData?.length}
                type={"verticalBar"}
                heading={"Top 10 Most Rated"}
                graphData={userRatedBarData}
                xAxesText={"LoginId"}
                yAxesText={"Rated Count"}
              />
            </div>
            <div className={classes.graphicalReport_bar}>
              <ReportGraph
                totalPercentage={userMostPassedData?.length}
                type={"verticalBar"}
                heading={"Top 10 Most Passed"}
                graphData={userPassBarData}
                xAxesText={"LoginId"}
                yAxesText={"Passed Count"}
              />
            </div>
          </div>
          {/* <div className={classes.graphicalReport_bar_main}>
            <div className={classes.graphicalReport_bar}>
              <ReportGraph
                totalPercentage={userMostCreditData?.length}
                type={"verticalBar"}
                heading={"Top 10 Most Credit"}
                graphData={userCreditBarData}
                xAxesText={"LoginId"}
                yAxesText={"Credit Count"}
              />
            </div>
          </div> */}
        </div>
      )}
    </>
  );
};

export default injectIntl(UserGraphicalReport);
